export default {
  selectSize: 'Proszę wybrać pełną specyfikację',
  inventory: 'Stan magazynowy',
  num: 'Ilość',
  nimNumTips: 'Minimalna ilość zakupu: {num}',
  addCart: 'Dodaj do koszyka',
  nowBuy: 'Kup teraz',
  remark: 'Zostaw wiadomość',
  goShop: 'WEJDŹ DO SKLEPU',
  productTotalPrice: 'Całkowita cena produktu',
  productDetail: 'Szczegóły produktu',
  sizeParams: 'Parametry specyfikacji',
  shopNotes: 'Uwagi agenta zakupowego',
  saleService: 'Obsługa posprzedażowa',
  productInfo: 'Informacje o produkcie',
  buyTips:
    'Zamówienia opłacone między 09:00-18:00 (czas pekiński) zostaną przetworzone w ciągu 6 godzin (z wyjątkiem niedziel).',
  buyer: 'Sprzedawca',
  selfWarehouse: 'Wybrany magazyn acbuy',
  warehouse: 'Wybrany magazyn acbuy',
  yourAddress: 'Twój adres',
  calcCountryFreight: 'Oszacuj koszt wysyłki międzynarodowej',
  holder: {
    remarkHolder:
      'Jeśli masz jakieś inne potrzeby, zostaw wiadomość w uwagach, agent pomoże Ci w zapytaniu.',
  },
  supportPayment: 'Dostępne metody płatności',
  disclaimer:
    'Wszystkie produkty dostępne w usłudze agenta zakupowego wyświetlane na acbuy pochodzą z zewnętrznych platform zakupowych i nie są sprzedawane bezpośrednio przez acbuy. W związku z tym acbuy nie ponosi odpowiedzialności prawnej za problemy spowodowane naruszeniem praw własności intelektualnej i naruszeniem praw autorskich do towarów.',
  readAgree: 'Przeczytałem i zaakceptowałem powyższe',
  selectAgree: 'Nie zaakceptowano zastrzeżeń',
  copyLink: 'Kopiuj link',
  copySuccess: 'Skopiowano pomyślnie',
  disclaimer1: 'Zastrzeżenia',
  editPrice: 'Edytuj cenę',
  editPriceTips:
    'Uwaga: występuje problem z realizacją kuponu. Zalecamy użytkownikowi zmianę ceny sprzedaży produktu na cenę oryginalną.',
  editPriceEnum: {
    0: 'Zniżka na wysyłkę',
    1: 'Błąd ceny na stronie',
    2: 'Negocjacje ze sprzedawcą',
    3: 'Inny powód',
  },
  imgTranslation: 'Tłumaczenie obrazów',
  translationTips: 'Kliknij na obrazek, aby przetłumaczyć tekst',
  originTranslation: 'Oryginalny obraz/tłumaczenie',
  qcImg: 'Zdjęcie QC',
  deleteShopCollect: 'Czy na pewno chcesz usunąć kolekcję tego sklepu',
  inTransition: 'W okresie przejściowym...',
  originLink: 'Oryginalne łącze',
  singleProductData: 'Dane dotyczące pojedynczego produktu',
  recentlyViewed: 'Ostatnio oglądane',
}
